var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPointer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1045 18.8955C14.2292 17.0202 14.2292 13.9798 16.1045 12.1045C17.9798 10.2292 21.0202 10.2292 22.8955 12.1045C24.7708 13.9798 24.7708 17.0202 22.8955 18.8955C21.0202 20.7708 17.9798 20.7708 16.1045 18.8955ZM19.5 5.24C13.777 5.24 9.24 9.82526 9.24 15.5C9.24 16.6791 9.33775 17.4798 9.55844 18.2427C9.78509 19.0262 10.1883 19.9309 10.98 21.2584C12.0972 23.1317 13.7612 25.4926 16.3198 29.1226C17.2448 30.435 18.2868 31.9133 19.4621 33.5944C20.8512 31.6002 22.0553 29.8921 23.1015 28.408C25.3969 25.152 26.9323 22.9739 27.9945 21.216C28.7977 19.8868 29.2065 18.9883 29.4366 18.2123C29.6595 17.4604 29.76 16.6706 29.76 15.5C29.76 9.83628 25.1637 5.24 19.5 5.24ZM18.0938 37.2969C16.4481 34.9299 15.0193 32.9025 13.7801 31.1442C7.28898 21.9341 6 20.1052 6 15.5C6 8.04688 11.9766 2 19.5 2C26.9531 2 33 8.04688 33 15.5C33 19.9883 31.7285 21.7924 25.64 30.4314C24.2888 32.3486 22.7004 34.6024 20.8359 37.2969C20.4844 37.7891 19.9922 38 19.5 38C18.9375 38 18.4453 37.7891 18.0938 37.2969Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointer);
export default __webpack_public_path__ + "static/media/pointer.8933974bc7215a45b4c6a3b98441342a.svg";
export { ForwardRef as ReactComponent };